import type {Expand} from '../../types';

export const fileExpandCommon: Expand = {};
